import { useTheme } from "@emotion/react";
import { CcRootContext } from "../../conversionCenterRoot";
import React, { useState, useContext, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import CcInput from "../ccInput";
import { getArrayLastItem, sortByPosition } from "../../helpers/helpers";
import { EMAIL_REGEXP } from "../../../../utils/constants";

export const Questionary = ({ data, defaultScreen }) => {
  const ctx = useContext(CcRootContext);
  const current = defaultScreen || getArrayLastItem(ctx.history);
  const theme = useTheme();
  const formRef = useRef(null);
  const [locked, setLocked] = useState(false);
  const { register, handleSubmit, errors, reset } = useForm();
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const onSubmit = (data) => {
    const { email, name, ...rest } = data;
    setLocked(true);
    const contactUuid = ctx.sites
      .find((site) => site.specialtyName === current.activeSpecialty).elements
      .find((element) => element.type === "Contact").contactUuid;
    const formData = {
      contact_uuid: contactUuid,
      email: email,
      message: `${name} requests a contact`,
      details: {
        name: name,
        ...rest,
      },
    };

    fetch("/api/public/contact_requests/", {
      method: "POST",
      headers: {
        "accept": "*/*",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({
        ...formData,
        contact_request: formData,
      }),
    })
      .then((resp) => {
        if(resp.ok) {
          setShowSuccessMsg(true);
          formRef.current.querySelectorAll('label').forEach((label) => {
            label.classList.remove("focused");
          });
          reset();
        }
        setLocked(false);
      })
      .catch((error) => {
        setLocked(false);
        console.error(error);
      });
  };

  useEffect(() => {
    if (!showSuccessMsg) return;
    setTimeout(() => {
      setShowSuccessMsg(false)
    }, 8000);
  }, [showSuccessMsg]);

  const headingStyle = {
    fontFamily: theme.font.primary,
    margin: "9px 0 7px",
  };

  const subHeadingStyle = {
    fontFamily: theme.font.primary,
    margin: 0,
    marginBottom: 15,
  };

  const submitButtonStyle = {
    backgroundColor: theme.colors.primary,
    border: `1px solid ${theme.colors.primary}`,
    borderRadius: 3,
    boxSizing: "border-box",
    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
    color: theme.colors.white,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 39,
    width: "100%",
    marginTop: 23,
    transition: "all .2s ease-in-out",
    "&:hover": {
      backgroundColor: theme.colors.white,
      color: theme.colors.primary,
    },
    "&:disabled": {
      cursor: "not-allowed",
      filter: "grayscale(.75)",
    }
  };

  const successMsgStyle = {
    color: theme.colors.success,
    fontWeight: 500,
    textAlign: "center",
  };

  const localFields = [
    { required: true, active: true, fieldName: "name" },
    { required: true, active: true, fieldName: "email" },
    ...sortByPosition(data?.fields.map((field) => ({ ...field, numberInOrder: field.id}))),
  ];

  return (
    <>
      <h2 css={headingStyle}>{data?.title ||"Request a call"}</h2>
      <p css={subHeadingStyle}>Please provide your contact info and we'll promptly reach out to you.</p>
      {showSuccessMsg && (
        <p css={successMsgStyle}>Your call request have been submitted. We will contact you soon.</p>
      )}
      <form
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
        css={{ padding: "15px 36px 0" }}
        ref={formRef}
      >
        {localFields.map((field) => {
          if (!field.active) return null;
          return (
            <CcInput
              key={field.fieldName}
              defaultValue=""
              id={field.fieldName}
              name={field.fieldName}
              data={field}
              register={register({ 
                required: field.required ? `${field.fieldName.split("_").join(" ")} cannot be empty` : false,
                pattern: field.fieldName === 'email' ? {
                  value: EMAIL_REGEXP,
                  message: "Email is in wrong format",
                } : false,
              })}
              error={errors[field.fieldName]}
            />
          );
        })}
        <button
          css={submitButtonStyle}
          type="submit"
          disabled={locked}
        >
          Submit
        </button>
      </form>
    </>
  );
};
